import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import {mapActions, mapGetters} from 'vuex';
import * as usertypes from '@account/store/types';
import * as gnbTypes from '@gnb/store/types';

// component
import SearchForm from '@home/components/Search/SearchForm.vue'
import SearchResultBoard from '@home/components/Search/SearchResultBoard.vue'
import SearchResultOrg from '@home/components/Search/SearchResultOrg.vue'
import { createEventBus } from '@/modules/@appbase/util';
import api from "@gnb/api";

@Component({
    components: {
        SearchForm,
        SearchResultBoard,
        SearchResultOrg
    },
    computed: mapGetters({
        userCurrent: usertypes.CURRENT
    }),
    methods: mapActions({
        wisenutSearch: gnbTypes.WISENUT_SEARCH
    })
})
export default class SearchContainer extends Vue {
    @Prop({type:Boolean}) useSearchSystem!: boolean

    userCurrent!: account.TCurrent;
    searchText: string = ''
    searchBaseUrl : string = ""
    isLoading: boolean = false

    ifrmSearch: HTMLIFrameElement | null= null;
   
    // DB검색용 화면 데이터
    currentPage: number = 1
    pageSize: number = 6
    articleList: gnbarticle.Article[] = []
    articleCount: number = 0
    userLang: string = ''

    wisenutSearch!: (payload: { keyWord: string, page: number, size: number }) => Promise<{ articleList: gnbarticle.Article[], articleCount: number}>;

    created(){          
        createEventBus(window, 'portal-goBoardDetail', this.boardDetailHandler);
        
        this.userLang = this.userCurrent.userConfig.language
        let reqSearch = (this.$route.query.searchText ? this.$route.query.searchText.toString() : '')        
        this.searchText = reqSearch;
        this.searchBaseUrl = `${window.location.origin}/srch`

        this.isLoading = true;
        this.fnTotalSearch(this.searchText);
    }  

    fnTotalSearch(text: string) {
        this.searchText = text;
        // 게시판 데이터 검색
        this.fnSearchArticle(this.currentPage, this.pageSize);
    }
    
    // 게시글 검색
    fnSearchArticle(pageNum: number, pageSize: number){
        this.isLoading = true;

        this.currentPage = pageNum;
        this.pageSize = pageSize

        // 게시판 데이터 검색(DB)
        if(!this.useSearchSystem){
            api.gnb.searchArticles(this.searchText,this.currentPage,this.pageSize = pageSize)
            .then(res=>{
                if (res){
                    this.articleList = res.data;
                    this.articleCount = res.totalCount;
                }
                this.isLoading = false;
            }).catch(err => {
                console.error('Search error:', err);
                this.articleList = [];
                this.articleCount = 0;
                this.isLoading = false;
            });
        }
        else{
            this.fnSearchArticleByWisenutEngine(pageNum, pageSize);
        }
    }

    fnSearchArticleByWisenutEngine(pageNum: number, pageSize: number){
        this.isLoading = true;

        this.currentPage = pageNum;
        this.pageSize = pageSize;

        this.wisenutSearch({ keyWord: this.searchText, page: this.currentPage, size: this.pageSize })
            .then(res => {
                if (res) {
                    this.articleList = res.articleList;
                    this.articleCount = res.articleCount;
                }
                this.isLoading = false;
            })
            .catch(err => {
                console.error('Wisenut search error:', err);
                this.articleList = [];
                this.articleCount = 0;
                this.isLoading = false;
            });
    }

    boardDetailHandler(data: { boardId: number, articleId: number, volumeName: string }) {
        this.$router.push({
            path: 'modal/read',
            append: true,
            query: {
                SYSID: data.boardId.toString(),
                ARTICLEID: data.articleId.toString()           
            }
        })
    }

}